module.exports = __webpack_public_path__ + "img/signature@2x.23c09a6.jpg";